import React, { Component } from 'react';
import './App.css';
import Header from './components/Header/Header'
/*youttubeSearchとしてnpmでインストールしたyoutube-api-searchをimport*/
import youtubeSearch from 'youtube-api-search';
import Body from './components/Body/Body';
import List from './components/Video/List/List';
import Video from './components/Video/Video';
import Colorpicker from './components/Colorpicker/Colorpicker';


/*YoutubeAPIのAPIIキー*/
const YOUTUBE_API_KEY = "AIzaSyBm3d0DKbPFQNehr-gEfTz3wR2T0HldDw8"

youtubeSearch({ key: YOUTUBE_API_KEY, term: 'ペンギン かわいい' }, (data) => {
  console.log(data);
});

class App extends Component {

  /*stateの初期化。取得するデータは配列なので、[]と設定*/
  state = {
    videos: [],
    selectedVideo: null
  }

  /*componentDidMountでAPIリクエスト*/
  componentDidMount() {
    youtubeSearch({ key: YOUTUBE_API_KEY, term: 'ペンギン かわいい' }, (data) => {
      this.setState({ videos: data, selectedVideo: data[2] });
    });
  }

  /*clickされたら、その動画をとってくる*/
  onVideoClickedHandler = (video) => {
    this.setState({ selectedVideo: video })
  }

  /*検索したい言葉を引数にとり、最初にペンギンという文字列をつけて検索する*/
  onKeywordChangedHandler = (keyword) => {
    let newTerm = 'ペンギン' + keyword;
    /*検索バーが空のときは「ペンギン かわいい」の動画を表示*/
    if (keyword === ' ') {
      newTerm = 'ペンギン かわいい';
    }

    youtubeSearch({ key: YOUTUBE_API_KEY, term: newTerm }, (data) => {
      this.setState({ videos: data, selectedVideo: data[0] })
    });
  }

  render() {
    return (
      <div className="App">

        <Header onKeywordChanged={this.onKeywordChangedHandler} />
        {/*このBodyタグの中に、Video.jsやList.jsが入る*/}
        {/*ListをBodyタグの間に挿入*/}
        <Body>
          <Video video={this.state.selectedVideo} />
          <List videos={this.state.videos}
            onVideoClicked={this.onVideoClickedHandler}
            selectedVideo={this.state.selectedVideo}
          />

        </Body>
        <Colorpicker />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js